var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-container",
        { staticClass: "auth-container word-container" },
        [
          _c(
            "el-aside",
            { staticClass: "auth-aside", attrs: { width: "200px" } },
            [
              _c(
                "el-input",
                {
                  staticClass: "search-type",
                  attrs: {
                    placeholder: "输入分类名称搜索",
                    clearable: "",
                    size: "mini"
                  },
                  model: {
                    value: _vm.filterText,
                    callback: function($$v) {
                      _vm.filterText = $$v
                    },
                    expression: "filterText"
                  }
                },
                [
                  _c("i", {
                    staticClass: "el-input__icon el-icon-search",
                    attrs: { slot: "suffix" },
                    slot: "suffix"
                  })
                ]
              ),
              _c("el-tree", {
                ref: "authTree",
                staticClass: "tree filter-tree",
                staticStyle: { height: "100%" },
                attrs: {
                  data: _vm.listData,
                  "node-key": "departmentId",
                  "default-expanded-keys": _vm.defaultShowNodes,
                  "default-checked-keys": _vm.defaultCheckedKeys,
                  "expand-on-click-node": false,
                  "current-node-key": _vm.currentNodeKey,
                  "highlight-current": true,
                  "check-on-click-node": true,
                  props: _vm.defaultProps
                },
                on: {
                  "node-click": _vm.nodeClick,
                  check: _vm.handleCheckChange
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var node = ref.node
                      var data = ref.data
                      return _c("span", { staticClass: "custom-tree-node" }, [
                        _c("span", [_vm._v(_vm._s(node.label))]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              position: "absolute",
                              top: "5px",
                              right: "10px",
                              "z-index": "9999"
                            }
                          },
                          [
                            _c(
                              "el-popover",
                              {
                                ref: "popover-" + node.id,
                                attrs: {
                                  placement: "right",
                                  width: "60",
                                  trigger: "click"
                                }
                              },
                              [
                                _c("ul", { staticClass: "popover-ul" }, [
                                  _c(
                                    "li",
                                    {
                                      style:
                                        _vm.clickTap == 1
                                          ? "background-color: #ECEFF4"
                                          : ""
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.addTree(
                                                node,
                                                data,
                                                "新增"
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("新建子分类")]
                                      )
                                    ]
                                  ),
                                  _c(
                                    "li",
                                    {
                                      style:
                                        _vm.clickTap == 2
                                          ? "background-color: #ECEFF4"
                                          : "",
                                      on: {
                                        click: function() {
                                          return _vm.addTree(node, data, "修改")
                                        }
                                      }
                                    },
                                    [_vm._v(" 修改分类 ")]
                                  ),
                                  _c(
                                    "li",
                                    {
                                      style:
                                        _vm.clickTap == 3
                                          ? "background-color: #ECEFF4"
                                          : "",
                                      on: {
                                        click: function() {
                                          return _vm.remove(node, data)
                                        }
                                      }
                                    },
                                    [_vm._v(" 删除分类 ")]
                                  )
                                ]),
                                _c("i", {
                                  staticClass: "el-icon-s-tools",
                                  attrs: { slot: "reference" },
                                  on: {
                                    click: function($event) {
                                      return _vm.closePopover(
                                        "popover-" + node.id
                                      )
                                    }
                                  },
                                  slot: "reference"
                                })
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-main",
            { staticClass: "auth-main" },
            [
              _c(
                "el-col",
                {
                  staticStyle: {
                    float: "left",
                    "margin-bottom": "10px",
                    "margin-right": "10px"
                  },
                  attrs: { span: 3 }
                },
                [
                  _c(
                    "el-input",
                    {
                      attrs: {
                        size: "mini",
                        placeholder: "敏感词",
                        clearable: ""
                      },
                      on: { blur: _vm.blurWord, clear: _vm.clearWord },
                      model: {
                        value: _vm.querySensitiveWord,
                        callback: function($$v) {
                          _vm.querySensitiveWord = $$v
                        },
                        expression: "querySensitiveWord"
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "el-input__icon el-icon-search",
                        attrs: { slot: "suffix" },
                        slot: "suffix"
                      })
                    ]
                  )
                ],
                1
              ),
              _c(
                "el-col",
                {
                  staticStyle: {
                    float: "right",
                    "margin-bottom": "10px",
                    "text-align": "right"
                  },
                  attrs: { span: 3 }
                },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary", size: "mini" } },
                    [_vm._v("添加敏感词")]
                  )
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading"
                    }
                  ],
                  ref: "singleTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    size: "medium",
                    "header-cell-style": {
                      background: "#eef1f6",
                      color: "#606266"
                    },
                    height: _vm.tableHeight,
                    "highlight-current-row": true,
                    data: _vm.tableData,
                    "element-loading-text": "读取数据加载中"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "55" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "sensitiveWord",
                      label: "敏感词",
                      "min-width": "200",
                      align: "center"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "mobile",
                      label: "补充词语",
                      "min-width": "150",
                      align: "center"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "departmentName",
                      label: "不包含词语",
                      "min-width": "280",
                      align: "center"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "departmentName",
                      label: "操作人",
                      "min-width": "280",
                      align: "center"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "userId",
                      label: "操作时间",
                      "min-width": "150px"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      fixed: "right",
                      prop: "status",
                      label: "操作",
                      width: "120"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function($event) {
                                    return _vm.handleEdit(scope.row)
                                  }
                                }
                              },
                              [_vm._v("修改")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function($event) {
                                    return _vm.handleDel(scope.row)
                                  }
                                }
                              },
                              [_vm._v("删除")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c("Pagination", {
                attrs: { childMsg: _vm.pageparm, pageSizes: _vm.pageSizes },
                on: { callBack: _vm.callBack }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }